import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type BrokerAdminTabProps = {
    label: string;
};

const BrokerAgentsRoute = '/brokeragents';

let routes = [BrokerAgentsRoute];

function BrokerAdminTab({ label, ...props }: BrokerAdminTabProps) {
    function handleClick() {
        history.push(BrokerAgentsRoute);
    }

    return <BaseTab {...props} onClick={handleClick} label={label} route={BrokerAgentsRoute} />;
}

function TranslatedBrokerAdminTab(props) {
    const label = Translate('header/nav/brokeragents');
    return <BrokerAdminTab {...props} label={label} />;
}

TranslatedBrokerAdminTab.routes = routes;

export default TranslatedBrokerAdminTab;
